import React from 'react';
import { useTranslation } from 'react-i18next';

import InfoIcon from '@/assets/icons/Info.svg';

const Introduce = () => {
  const { t } = useTranslation();

  return (
    <div className='mb-[12px]'>
      <p className='mb-[12px] font-semibold text-[18px] leading-[25px] text-[#12212E]'>{t('inquiry:introduction')}</p>
      <div className='flex'>
        <div className='py-[2px] mr-[4px]'>
          <InfoIcon width={14.63} height={14.63} />
        </div>
        <div className='font-normal leading-[22px] text-[14px] text-[#525A68]'>
          <p>{t('inquiry:introduction_detail_1')}</p>
          <p>{t('inquiry:introduction_detail_2')}</p>
        </div>
      </div>
    </div>
  );
};

export default Introduce;
